export type StakeModel = {
	id: string;
	name: string;
	reference: string;
	description: string;
	weight: number;
	trend: string;
	createdAt: string;
	evaluatedAt: string;
	enabled: boolean;
};

export const defaults = {
	__typename: 'Stake',
	reference: '',
	weight: 1,
	trend: '50',
	description: '',
	evaluatedAt: '',
	scenarios: [],
	createdAt: '2025-02-11T14:26:13.594Z',
	enabled: true
};
